export default "__VITE_ASSET__CpUjpoiL__"